import React, { useState, useEffect } from 'react';
import { isMobileDevice } from '../../../common/utilities/utils';
import ModalComponent from 'molecules/Modal';
import { ButtonComp } from 'atoms/Buttons';
import { getValidFormatDate } from 'organisms/CouponsLanding/utils/CouponUtils';
import { handleRedeemClick } from 'organisms/OffersAndPromotions/OffersAndPromotionsUtilities/offersAndPromotionsUtils';
import {
  MODAL_HEADER_TEXT_MOBILE,
  MODAL_HEADER_TEXT_DESKTOP,
  OFFER_APPLIED,
  REDEEM,
  VALID_TO,
} from '../constants/offersAndDealsConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
/**
 * Render login form in a popup modal Component
 * @param {*} props - Object
 */
export const DealsDetailModal = props => {
  const { isDealModalOpen, handleClose, data = {}, couponApplyHandler } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));

  const modalProps = isMobile
    ? {
        id: 'dealDetailsPopUp',
        role: 'dialog',
        modalTitleId: 'dealDetailsPopUp',
        show: { isDealModalOpen },
        classNames: 'deals-module-modal',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        modalTitle: translateWithI18Next(MODAL_HEADER_TEXT_MOBILE),
        autoFocus: true,
      }
    : {
        id: 'dealDetailsPopUp',
        role: 'dialog',
        modalTitleId: 'dealDetailsPopUp',
        show: { isDealModalOpen },
        classNames: 'deals-module-modal',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        modalTitle: translateWithI18Next(MODAL_HEADER_TEXT_DESKTOP),
        autoFocus: true,
      };

  /**
   * useEffect to add and cleanup of window resize event
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  return (
    <React.Fragment>
      <ModalComponent {...modalProps} data-testid='offers-deals-modal-testid'>
        <div className='offers-coupon-mid-box'>
          <h4 className='offers-modal-mid-header'>{data?.heading}</h4>
          {data?.endTime && (
            <h5 className='offers-deals-product-valid'>
              {`${translateWithI18Next(VALID_TO)} ${getValidFormatDate(data?.endTime)}`}
            </h5>
          )}
          <p className='offers-modal-mid-desc'>{data?.description}</p>
          <div className='offers-modal-deals-footer'>
            <ButtonComp
              data-testid='redeem-btn-testid'
              disabled={data?.isApplied}
              onClick={() => handleRedeemClick(data?.discountCode, couponApplyHandler, handleClose)}
              className='redeem-btn'
            >
              <span className='btn-text'>
                {data?.isApplied ? translateWithI18Next(OFFER_APPLIED) : translateWithI18Next(REDEEM)}
              </span>
            </ButtonComp>
          </div>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};

export default DealsDetailModal;
